import * as React from 'react';
import { PureComponent } from 'react';
import moment from 'moment'

const tooltip = {
  pointerEvents: 'none',
  position: 'relative',
  minWidth: '150px',
  height: 'auto',
  background: 'rgba(33, 49, 49, 0.8)',
  borderRadius: '8px',
  padding: '8px',
  zIndex: 9,
  color: '#fff',
};

export default class MarkerInfo extends PureComponent {
  render() {
    const { info } = this.props;
    return (
      <div style={tooltip}>
        {info.deviceName && <div>
          Device : {info.deviceName}
        </div>}
        <div>
          Time : {info.time}
        </div>
        <div>
          Avg CR (in um/y) : {info.avg1}
        </div>
        <div>
          Avg CR (in mpy) : {info.avg2} 
        </div>
        <div>
          Max CR (in um/y) : {info.max1}
        </div>
        <div>
          Max CR (in mpy) : {info.max2}
        </div>
        <div>
          Depth : {info.depth} m
        </div>
      </div>
    );
  }
}